import { Injectable } from '@angular/core';
import { RemoteDiagnosticsCloudMockApi } from '@vi-iot/client/apis/remote-diagnostics/remote-diagnostics-cloud.mock.api';
import { AuthStore } from '@store';
import { BaseApiPickerImpl } from '../base.api-picker';
import { RemoteDiagnosticsCloudApi } from './remote-diagnostics-cloud.api';

@Injectable({ providedIn: 'root' })
export class RemoteDiagnosticsCloudApiPicker extends BaseApiPickerImpl<
  RemoteDiagnosticsCloudApi | RemoteDiagnosticsCloudMockApi
> {
  constructor(
    authStore: AuthStore,
    realApi: RemoteDiagnosticsCloudApi,
    mockApi: RemoteDiagnosticsCloudMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
